import gql from 'graphql-tag';
import { graphMutation, graphQuery } from '@services/commService';

export const createEntity = async (info, components, pollID) => {
  const { name, description, surveySchema, skipPollEnabled = false } = info;
  const mutation = gql`
  mutation($surveySchema: JSON, $skipPollEnabled: Boolean) {
    createdEntity:createEntityPoll(
      name:"${name}",
      description:"""${description}""",
      surveySchema:$surveySchema,
      skipPollEnabled:$skipPollEnabled
       ){
        id 
        description
        name
        surveySchema
        skipPollEnabled
        createdAt
      }
    }
  `;
  return await graphMutation(mutation, {
    surveySchema: surveySchema || null,
    skipPollEnabled,
  });
};

export const editEntity = async (info, components, pollID) => {
  const { name, description, surveySchema, skipPollEnabled = false } = info;
  const mutation = gql`
  mutation($surveySchema: JSON, $skipPollEnabled: Boolean) {
    modifyPoll(
      id:"${info.id}",
      name:"${name}",
      description:"""${description}""",
      surveySchema:$surveySchema,
      skipPollEnabled:$skipPollEnabled
       ){
        id 
        description
        name
        surveySchema
        skipPollEnabled
        createdAt
      }
    }
  `;
  return await graphMutation(mutation, {
    surveySchema: surveySchema || null,
    skipPollEnabled,
  });
};
export const deleteEntity = async(id)=>{
  
  const mutation = `mutation{
    deletePoll(
      id:"${id}"
    ){
      name
    }

  }`
  
  return await graphMutation(mutation,{}, true);
}

export const loadEntity = async (id) => {
  const query = gql`
  {
    entity:entityPolls(id:"${id}",range:[0,1],fullData:true){
    id
    name
    createdAt
    description
    surveySchema
    skipPollEnabled
  }}
  `;
  return await graphQuery(query);
};
